import { render, staticRenderFns } from "./import_card.vue?vue&type=template&id=f6a86e2c&scoped=true&"
import script from "./import_card.vue?vue&type=script&lang=js&"
export * from "./import_card.vue?vue&type=script&lang=js&"
import style0 from "./import_card.vue?vue&type=style&index=0&id=f6a86e2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6a86e2c",
  null
  
)

export default component.exports